// extracted by mini-css-extract-plugin
export default {"container":"DownloadOptionModal_container__AAp41","description":"DownloadOptionModal_description__IZGOB","button":"DownloadOptionModal_button__ujvyU"};